import authRoles from 'app/auth/authRoles';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const MyBrandsPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.brandPicker,
  routes: [
    {
      path: routesUrl.myBrands,
      exact: true,
      component: React.lazy(() => import('./MyBrandsPage')),
    },
  ],
};

export default MyBrandsPageConfig;
